import { useCallback } from 'react';
import type { RecoilState } from 'recoil';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { librarySelectedIdsAtom, privateLibrarySelectedIdsAtom } from 'venn-state';

export const useReturnsLibrarySelection = () => {
  return useLibrarySelection(librarySelectedIdsAtom);
};
export const usePrivateLibrarySelection = () => {
  return useLibrarySelection(privateLibrarySelectedIdsAtom);
};

export const useLibrarySelection = (selectionAtom: RecoilState<string[]>) => {
  const [selectedIds, setSelectedIds] = useRecoilState(selectionAtom);
  const clearSelectedIds = useResetRecoilState(selectionAtom);

  const toggleSelectedId = useCallback(
    (id: string) => {
      setSelectedIds((prev) => (prev.includes(id) ? prev.filter((prevId) => prevId !== id) : [...prev, id]));
    },
    [setSelectedIds],
  );

  const setIdsSelected = useCallback(
    (ids: string[], selected: boolean) => {
      setSelectedIds((prev) => {
        const next = selected ? Array.from(new Set([...prev, ...ids])) : prev.filter((prevId) => !ids.includes(prevId));
        return next.length === prev.length ? prev : next;
      });
    },
    [setSelectedIds],
  );

  return { selectedIds, setSelectedIds, toggleSelectedId, setIdsSelected, clearSelectedIds };
};
